export * from './Setting';
export * from './Auth';
export * from './Modelo';
export * from './Cliente';
export * from './Equipamento';
export * from './LocalControlado';
export * from './PontoAcesso';
export * from './Perfil';
export * from './UsuarioPlataforma';
export * from './AcessoPerfil';
export * from './AcessoPessoa';
export * from './AcessoGenero';
export * from './AcessoIdade';
export * from './AcessoPeriodo';
export * from './Global';
export * from './Aluno';
export * from './Curso';
export * from './Serie';
export * from './Turma';
export * from './Notificacao';
export * from './RecuperarSenhaApp';
export * from './Cantina';
